export class ApiError extends Error {
	status: number | null
	code?: string
	details?: unknown

	constructor(status: number | null, message: string, code?: string, details?: unknown) {
		super(message)
		this.status = status
		this.code = code
		this.details = details
		this.name = 'ApiError'
	}

	isValidationError() {
		return this.status === 400 && this.details && typeof this.details === 'object'
	}
}

export async function handleNonOkResponse(res: Response, defaultMessage = 'Request failed') {
	let msg = defaultMessage
	let code: string | undefined
	let details: unknown
	try {
		const data = await res.json()
		if (data) {
			msg = data?.message ?? msg
			code = data?.code
			details = data?.details
		}
	} catch (err) {
		// eslint-disable-next-line no-console
		console.log('Error parsing JSON response:', err)
		// ignore JSON parse errors and fall back to a friendly default message
	}
	throw new ApiError(res.status, msg, code, details)
}
